import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { registerSW } from 'virtual:pwa-register';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root container "#root" was not found in the document.');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// The service worker (src/sw.ts): installs the app, keeps the shell offline, carries push. A new build takes over on the next load.
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  registerSW({ immediate: true });
}
